import { PDFDocument, StandardFonts, rgb } from "pdf-lib";

/**
 * Loads the site waiver PDF and appends a page with visitor details + drawn signature (PNG).
 */
export async function buildSignedVisitorWaiverPdf({
  waiverUrl,
  name,
  email,
  company,
  hostName,
  visitDate,
  signaturePngBytes,
}) {
  const res = await fetch(waiverUrl);
  if (!res.ok) {
    throw new Error("Could not load the waiver PDF from the site.");
  }
  const existing = await res.arrayBuffer();
  const pdfDoc = await PDFDocument.load(existing);

  const { width, height } = pdfDoc.getPage(0).getSize();
  const page = pdfDoc.addPage([width, height]);

  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const bold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  let y = height - 56;

  const draw = (text, size = 11, useBold = false) => {
    const f = useBold ? bold : font;
    page.drawText(text, {
      x: 48,
      y,
      size,
      font: f,
      color: rgb(0.12, 0.12, 0.12),
      maxWidth: width - 96,
    });
    y -= size + 12;
  };

  draw("VISITOR CHECK-IN: ELECTRONIC SIGNATURE RECORD", 13, true);
  y -= 4;
  draw(`Visitor name: ${name}`);
  draw(`Email: ${email}`);
  if (company) draw(`Company / organization: ${company}`);
  if (hostName) draw(`MAG host: ${hostName}`);
  if (visitDate) draw(`Visit date: ${visitDate}`);
  draw(
    `Signed (device time): ${new Date().toLocaleString(undefined, {
      dateStyle: "long",
      timeStyle: "short",
    })}`
  );
  y -= 8;
  draw(
    "I confirm I have read the MAG Visitor Liability Waiver in this file and agree to be bound by its terms."
  );

  y -= 16;
  page.drawText("Signature:", { x: 48, y, size: 11, font: bold, color: rgb(0.12, 0.12, 0.12) });
  y -= 10;

  if (signaturePngBytes && signaturePngBytes.byteLength > 400) {
    const img = await pdfDoc.embedPng(signaturePngBytes);
    const maxW = Math.min(280, width - 96);
    const scale = maxW / img.width;
    const w = maxW;
    const h = img.height * scale;
    page.drawImage(img, { x: 48, y: y - h, width: w, height: h });
    y -= h + 24;
  }

  const pdfBytes = await pdfDoc.save();
  return new Blob([pdfBytes], { type: "application/pdf" });
}
